<template>
  <div id="loader-block"
    class="vs-con-loading__container"
    :class="{
      '_cover': cover
    }"
  >
    <slot v-if ="hasDefaultSlot"/>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  },
  props: {
    cover: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    open(){
      this.$vs.loading({
        container: '#loader-block',
        scale: 1
      })
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#loader-block > .con-vs-loading')
      // }, 3000);
    },
    close() {

    }
  },
  mounted() {
    this.open();
  }
}
</script>

<style lang="scss">
#loader-block {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &._cover {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
